module.exports = __webpack_public_path__ + "assets/img/21@3x.a9bf6650.png";